import { Component, OnInit ,Input ,Output , EventEmitter,HostListener,OnChanges, SimpleChanges,ContentChild,TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CopyUserService } from '../../service/copy-user.service';

@Component({
  selector: 'app-table-v2',
  templateUrl: './table-v2.component.html',
  styleUrls: ['./table-v2.component.css']
})
export class TableV2Component implements OnInit {

    isMobile: boolean;

    @Input() type: any;
    @Input() titleTableName: any = [];
    @Input() titleTableContent: any = [];
    @Input() aSum: any = {};
    @Input() tcontent: any;
    @Input() chickkey: any;
    @Input() data: any;
    @Input() topData: any=[];
    @Input() locktd: any = [ {nId:1}];
    @Input() pageobj: any={};
    @Input() loadmore: any;
    @Input() pagecount: any;
    @Input() sumopt: any = true;
    @Input() bounty_id: any=[];  //懸賞id
    @Input() bounty_arr: any=[]; //所有懸賞資料
    @Input() filter_title: any = false; //欄位顯示
    @Input() urltoken: any = ''; //欄位顯示
    @Input() urltokencsv: any = ''; //欄位顯示
    @Input() active: any = ''; //欄位顯示

    @Input() highlightCondition: boolean = false; // 表格是否要變為交錯灰色
    @Input() highlightColor: string = '#e9ecef'; // 表格是否要變為交錯灰色

    @Input() custom: any;
    @Input() sortableColumns: any;
    @Output() sortdata = new EventEmitter<{ event: Event }>();
    @Output() packet =  new EventEmitter<number>();
    @Output() link = new EventEmitter<{ event: Event }>();
    @Output() countp = new EventEmitter<number>();
    @Output() topDataout = new EventEmitter<{ event: Event }>();


    @ContentChild('operation_dk',{static: false}) operationTemplateRef_dk: TemplateRef<any>;
    @ContentChild('operation_hd',{static: false}) operationTemplateRef_hd: TemplateRef<any>;


    options: any[] = [{title:'Option 1'}, {title:'Option 1'}, {title:'Option 3'}, {title:'Option 4'}];
    selectedOptions: { [key: string]: boolean } = {};
    select_title_key= [];
    ori_title = [];
    ori_content = [];
    search_all_val = true;

    constructor(
        public httpClient: HttpClient,
        private copyUserService: CopyUserService
    ) {}

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.checkScreenSize();
    }

    tcontentTit = [];

    ngOnChanges(changes: SimpleChanges): void {

        if (!this.tcontent || !Array.isArray(this.tcontent)) {
            return;
        }

        // console.log("tcontent: " + JSON.stringify(this.tcontent));
        if (!this.tcontent || !Array.isArray(this.tcontent)) return;
        this.title = this.tcontent.map(({ title ,sort}) => ({ title ,sort}));
        // 這裡將傳入tcontent賦值給content。
        this.content = this.tcontent.map(({subcontentv1,subcontenttaxt1,subcontenttaxt, content, css, type, active, format, model, replaceArr}) => ({subcontentv1, subcontenttaxt1, subcontenttaxt, content, css, type, active, format, model, replaceArr}));
        this.checkScreenSize();

         // 找到第一個有 detal.sort 屬性的項目
        const firstSortableItem = this.title.find(item => item.sort);

        // 如果找到，將其 sort 值賦予 selectedSortType
        this.selectedSortType = firstSortableItem ? firstSortableItem.sort : '';

        //鎖td
        this.locktd.forEach(val => {

            if(val.nId > 0){
                val.nId = val.nId - 1;
            }

            let temnum = '0';
            if(val?.w?.length > 0){
                temnum = val.w;
            }

            if(this.title.length > 0){
                const titleCss = 'position: sticky; left:'+temnum+';  background: #313641;z-index: 999;';
                const contentCss = 'position: sticky; left:'+temnum+';  background: #f5f5f5;';

                this.title[val.nId].css = (this.title[val.nId].css ?? '') + titleCss;
                this.content[val.nId].css = (this.content[val.nId].css ?? '') + contentCss;
            }

        });

        if(this.pageobj?.total_count){
            this.page_start = (this.pageobj.page * this.pageobj.count) + 1;
            this.page_end = (this.pageobj.page * this.pageobj.count) + this.pageobj.count;

            if(this.input_tmp_pagelock){
                this.input_tmp_page = this.page_start;
            }
            this.input_tmp_pagelock = true;

        }

        this.ori_title = this.title;
        this.ori_content = this.content;

    }

    search_all(){

        if(this.search_all_val == true){
            this.options.forEach(option => {
                this.selectedOptions[option.title] = true; // 預設勾選所有選項
            });
        }else{
            this.options.forEach(option => {
                this.selectedOptions[option.title] = false; // 預設取消勾選所有選項
            });
        }

        this.search_option();

    }

    ngOnInit(): void {
        this.colorArray = Array.from({ length: 20 }, () => this.getRandomColor());
        this.option_title();
        this.check_copy_user();
        // console.log("type: " + this.type);
    }

    page_start = 1;
    page_end = 1;
    input_tmp_page = 0;
    title: any;
    content: any;
    CheckboxsTatus = false;
    input_tmp_pagelock = true;
    colorArray = [];
    copy_userId: string[] = [];
    flag:any={};
    packets:number=0;

    @HostListener('window:scroll', ['$event']) onScrollEvent($event){
        if(this.getYPosition($event) > 800)
          this.showbacktop = true;
        else
          this.showbacktop = false;
      }
      showbacktop: boolean = false;

    sort_obj:any = {column:'total',sort:'0'}
    selectedSortType:any = '';
    selectedSortOrder:any = '-1';

    /**
    * 檢查是否為盜圖用戶
    */

    isCopyrightViolation(userId: number | string): boolean {
        return this.copy_userId?.includes(String(userId));
    }

    check_copy_user() {
        this.copyUserService.getCopyUserId().subscribe(ids => {
            this.copy_userId = Array.isArray(ids) ? ids.map(x => String(x)) : [];
        });
    }

    search_option(){

        this.select_title_key = [];
        let num = 0;
        for (let key in this.selectedOptions) {
            if (this.selectedOptions.hasOwnProperty(key)) {
                if(this.selectedOptions[key] == true){
                    this.select_title_key.push(num);
                }
            }
            num++;
        }

        this.title =  this.reorganization(this.ori_title,this.select_title_key);
        this.content =  this.reorganization(this.ori_content,this.select_title_key);
    }

    //重組欄位和內容
    reorganization(item,key){

        let tmp = [];

        item.forEach((v,i) => {
            if (key.includes(i)) {
                tmp.push(v);
            }
        });

        return tmp;

    }


    option_title(){
        this.options = this.title;
        this.options.forEach(option => {
            this.selectedOptions[option.title] = true; // 預設勾選所有選項
        });
    }

    inputpage(){
        this.input_tmp_pagelock = false;
        let tmp_pageresult = this.input_tmp_page / this.pageobj.count;
        let integerResult = Math.floor(tmp_pageresult);
        this.countp.emit(integerResult);
    }


    onScroll(){

        var container = document.getElementById('lists-chats');

        let scrollvalue = container.scrollHeight - 484;

        if(this.isMobile == true){
            scrollvalue = container.scrollHeight - 504;
        }

        if(container.scrollTop > scrollvalue){
            clearTimeout(this.flag);
            this.flag = window.setTimeout(()=>{
            this.packets ++;

            if(this.packets < this.pagecount){
                this.select_table(this.packet);
                window.setTimeout(()=>{
                    let container2 = document.getElementById('lists-chats');
                    let new_height = container2.scrollHeight;
                    container.scrollTop = new_height/2;
                },400);
            }
          },800)

        }

    }

    select_table(packet){

        let scoll_bar_status = false;

        if(packet > 0){
          scoll_bar_status = true;
        }

        this.packet.emit(this.packets);

    }


    CheckboxChange(){
        this.CheckboxsTatus = !this.CheckboxsTatus
        this.topData = this.topData.map(item => ({ ...item, selected: this.CheckboxsTatus }));
        this.topDataout.emit(this.topData);

    }

    getYPosition(e: Event): number {
        return (e.target as Element)['scrollingElement'].scrollTop;
    }


    checkScreenSize() {
        this.isMobile = window.innerWidth <= 768; // 例如：小於等於768px視為手機板
    }

    go_top(){
        var btn_click = document.getElementById("go_top");
        const tmp = this.getOffset(btn_click);
    	this.scrollAnimation(tmp.top,0);
    }

    getOffset (el) {
        const box = el.getBoundingClientRect();
        return{
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        }
    }

    scrollAnimation(currentY, targetY) {
        let needScrollTop = targetY - currentY
        let _currentY = currentY
        setTimeout(() => {
            const dist = Math.ceil(needScrollTop / 10)
            _currentY += dist
            window.scrollTo(_currentY, currentY)
            if (needScrollTop > 10 || needScrollTop < -10) {
                this.scrollAnimation(_currentY, targetY)
            } else {
                window.scrollTo(_currentY, targetY)
            }
        }, 10)
    }
    sort_fnx(key,can_sort=1,sort){
        if(can_sort && sort != undefined){
            if(key==this.sort_obj.column){
                this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
            }else{
                this.sort_obj.column = key;
                this.sort_obj.sort = '0';
            }
            this.sortdata.emit(this.sort_obj);
        }
    }

    sort_fn(key,can_sort=1){
        if(can_sort){
            if(key==this.sort_obj.column){
                this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
            }else{
                this.sort_obj.column = key;
                this.sort_obj.sort = '0';
            }
            this.sortdata.emit(this.sort_obj);
        }
    }
    handleClick(link){
        this.link.emit(link);
    }


    cardsort_fn(key,can_sort=0){
        this.sort_obj.column = key;
        this.sort_obj.sort = can_sort;
        this.sortdata.emit(this.sort_obj);
    }

    shouldShowMobileSortPanel(): boolean {
        return this.title && this.title.some(detal => detal.sort !== undefined && detal.sort !== null);
    }


    getRandomColor() {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
}
